import React from 'react';
import P, { InferProps } from 'prop-types';
import { useStringsContext } from '../../../contexts/strings';
import { useTeamData } from '../../common/team';
import AppDetailsHeader from '../../common/team/header';
import Category from '../../common/team/category';
import { Box, Typography } from '@mui/material';
import ScenePage from '../../common/scene/scene-page';

function AppLinksInfo({ match }: InferProps<typeof AppLinksInfo.propTypes>) {
  const teamAbbrv = match.params.id;
  const { strings } = useStringsContext();
  const {
    categories,
    teamDocError,
    appConfigDocError,
    teamDocLoading,
    appConfigDocLoading,
    onSubmit,
    isValid,
    isReadOnly,
    isDirty,
    isSubmitting,
    isSuperAdmin,
    setChange,
    handleValidation,
  } = useTeamData(teamAbbrv);

  const pageCategories = categories.filter((category) =>
    ['Team Links', 'General Team Information'].includes(category.name)
  );

  return (
    <ScenePage title={strings.appBar.linksInfo}>
      {teamDocError || appConfigDocError ? (
        <p>{teamDocError?.message || appConfigDocError?.message}</p>
      ) : (
        <>
          {!teamDocLoading && !appConfigDocLoading && (
            <>
              <AppDetailsHeader
                onSubmit={onSubmit}
                isSubmitting={isSubmitting}
                isDisabled={!isValid || !!isReadOnly || !isDirty}
                title={strings.appBar.linksInfo}
                border
              />
              <Box sx={{ mt: 2 }}>
                {pageCategories.map((category) => (
                  <Box key={category.name} sx={{ mb: 5 }}>
                    {pageCategories.length > 1 ? (
                      <Typography variant="h6" sx={{ mb: 4, fontWeight: 400, ml: 3 }}>
                        {category.title}
                      </Typography>
                    ) : null}
                    <Category
                      teamAbbrv={teamAbbrv}
                      category={category}
                      path={teamAbbrv}
                      setChange={setChange}
                      setValidation={handleValidation}
                      isSuperAdmin={isSuperAdmin}
                    />
                  </Box>
                ))}
              </Box>
            </>
          )}
        </>
      )}
    </ScenePage>
  );
}

AppLinksInfo.propTypes = {
  match: P.shape({
    params: P.shape({
      id: P.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default AppLinksInfo;
